<template lang="pug">
.navbar.is-transparent
  .navbar-brand
    a.navbar-item(v-on:click="clickHome")
      b-tooltip(label="Home" position="is-bottom" type="is-dark")
        img(src="png/icon-196x196.png")
    .navbar-item.has-text-weight-semibold {{ title }}
    .navbar-burger(v-bind:class="{'is-active': isBurgerActive}" v-on:click="clickBurger")
      span
      span
      span
  .navbar-menu(v-bind:class="{'is-active': isBurgerActive}")
    .navbar-start
    .navbar-end
      template(v-if="apiToken")
        .navbar-item.has-dropdown.is-hoverable
          a.navbar-link.is-arrowless
            .icon
              i.fas.fa-user
            .navbar-dropdown.is-boxed.is-right
              a.navbar-item(v-on:click="clickClientBookings" v-if="isClient() && !hasInvalidClientProfile") Bookings
              a.navbar-item(v-on:click="clickProfessionalBookings" v-if="isProfessional() && !hasInvalidProfessionalProfile") Bookings
              a.navbar-item(v-on:click="clickProfessionalCalendar" v-if="isProfessional() && !hasInvalidProfessionalProfile") Calendar
              a.navbar-item(v-on:click="clickProfile") Profile
              a.navbar-item(v-on:click="clickWorkingHours" v-if="isProfessional()") Working Hours
              a.navbar-item(v-on:click="clickChangeOperator" v-if="isMultiOperator()") Change Operator
              a.navbar-item(v-on:click="clickZoom" v-if="isZoomClient()") Zoom
              a.navbar-item(v-on:click="clickLogOut") Log Out
      template(v-else)
        .navbar-item
          a.navbar-item(v-on:click="clickLogIn") Log In
        .navbar-item
          a.navbar-item(v-on:click="clickResetPassword") Reset Password
        .navbar-item
          a.navbar-item(v-on:click="clickSignUp") Sign Up
      .navbar-item.has-dropdown.is-hoverable
        a.navbar-link.is-arrowless
          .icon
            i.fas.fa-question
          .navbar-dropdown.is-boxed.is-right
            a.navbar-item(v-on:click="clickAbout") About
            a.navbar-item(v-on:click="clickContactUs") Contact Us
            a.navbar-item(v-on:click="clickLegal") Legal
            a.navbar-item(v-on:click="clickPrivacyPolicy") Privacy Policy
            a.navbar-item(v-on:click="clickTerms") Terms
</template>

<script>
import Constants from '@/constants'

import SelectOperatorForm from '@/components/SelectOperatorForm.vue'

import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  mixins: [
    ApiMixin
  ],
  data () {
    return {
      isBurgerActive: false
    }
  },
  computed: {
    isGoDo () {
      return this.apiOperator === undefined || this.apiOperator === null || this.apiOperator === 3
    },
    isOperator () {
      return Constants.OPERATOR !== 3
    },
    operatorSpecificTitle () {
      return `${Constants.TITLE_BRAND}${this.isOperator ? '' : this.isGoDo ? '' : ` (${this.operatorName})`}`
    },
    title () {
      if (Constants.OPERATOR === Constants.OPERATOR_DWFF) {
        return ''
      } else {
        return this.$route.meta.name ? this.$route.meta.name : this.operatorSpecificTitle
      }
    }
  },
  methods: {
    clickAbout () {
      this.isBurgerActive = false
      this.routerPush('/about')
    },
    clickBurger () {
      this.isBurgerActive = !this.isBurgerActive
    },
    clickChangeOperator () {
      this.isBurgerActive = false
      this.$buefy.modal.open({
        component: SelectOperatorForm,
        hasModalCard: true,
        parent: this,
        props: {
          impl: this.selectOperatorFormImpl,
          noun: 'Operator',
          operators: this.extractSharedOperators(),
          verbBase: 'Change',
          verbGerund: 'Changing'
        }
      })
    },
    clickClientBookings () {
      this.isBurgerActive = false
      this.routerPush('/')
    },
    clickContactUs () {
      this.isBurgerActive = false
      this.routerPush('/contact-us')
    },
    clickHome () {
      this.isBurgerActive = false
      this.routerPush('/')
    },
    clickLegal () {
      this.isBurgerActive = false
      this.routerPush('/legal')
    },
    clickLogIn () {
      this.isBurgerActive = false
      this.routerPush('/log-in')
    },
    clickLogOut () {
      this.isBurgerActive = false
      this.apiLogOut()
    },
    clickPrivacyPolicy () {
      this.isBurgerActive = false
      this.routerPush('/privacy-policy')
    },
    clickProfessionalBookings () {
      this.isBurgerActive = false
      this.routerPush('/')
    },
    clickProfessionalCalendar () {
      this.isBurgerActive = false
      this.routerPush('/professional-calendar')
    },
    clickProfile () {
      this.isBurgerActive = false
      this.routerPush('/profile')
    },
    clickResetPassword () {
      this.isBurgerActive = false
      this.routerPush('/reset-password')
    },
    clickSignUp () {
      this.isBurgerActive = false
      this.routerPush('/sign-up')
    },
    clickTerms () {
      this.isBurgerActive = false
      this.routerPush('/terms')
    },
    clickWorkingHours () {
      this.isBurgerActive = false
      this.routerPush('/working-hours')
    },
    clickZoom () {
      this.isBurgerActive = false
      this.routerPush('/zoom')
    }
  }
}
</script>
